import { render, staticRenderFns } from "./DisplayRichTextEditor.vue?vue&type=template&id=e36699a0&scoped=true"
import script from "./DisplayRichTextEditor.vue?vue&type=script&lang=js"
export * from "./DisplayRichTextEditor.vue?vue&type=script&lang=js"
import style0 from "./DisplayRichTextEditor.vue?vue&type=style&index=0&id=e36699a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36699a0",
  null
  
)

export default component.exports